import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { DestinationFrequentResponse } from "app/services/models/responses/destination-frequent.response";

export class GetDestinationFrequentByPassCommand extends IRequestCommand<
  IGetDestinationFrequentByPassResponse,
  ErrorDetails,
  IGetDestinationFrequentByPassParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override setParameters(params: IGetDestinationFrequentByPassParameters) {
    this.urlSections.push('carriers');
    this.urlSections.push(`${params.carrierUserId}`);
    this.urlSections.push('frequentDestinationByPass');
    this.urlSections.push(`${params.passId}`);
    
    this.composeUrl();
  }

}

export interface IGetDestinationFrequentByPassParameters
  extends ICommandParameters {
  carrierUserId: string;
  passId: number;
}

export interface IGetDestinationFrequentByPassResponse
  extends DestinationFrequentResponse,
    ICommandResponse {}
